import { api } from './client';
import type { Locale } from '../i18n';

export interface LisaSessionResponse {
  session_id: string;
  state: string;
  assistant_display_name: string;
  locale: string;
  opening_message: { text: string; quick_replies: string[] };
}

export interface RecommendationCard {
  type: string;
  content_id: string;
  title: string;
  reason: string;
  cta: { label: string; href: string };
}

export interface LisaMessageResponse {
  session_id: string;
  state: 'onboarding' | 'conversation' | 'qualification' | 'recommendation' | 'handover' | 'appointment' | 'error';
  reply: { text: string; quick_replies: string[]; recommendation_cards: RecommendationCard[] };
  disclosure_shown: boolean;
}

export interface LisaHandoverResponse {
  session_id: string;
  handover_id: string;
  routed_queue: string;
  summary: string;
  expected_response_window: string;
  state: string;
}

export const lisaApi = {
  createSession: (input: { locale: Locale; entry_point: string; page_context: { path?: string; content_id?: string }; consent: { analytics: boolean; conversation_storage: boolean } }) =>
    api.post<LisaSessionResponse>('/api/lisa/session', input),

  sendMessage: (input: { session_id: string; message: { type: 'text' | 'quick_reply'; value: string }; page_context?: { path?: string; content_id?: string } }) =>
    api.post<LisaMessageResponse>('/api/lisa/message', input),

  qualify: (input: {
    session_id: string;
    qualification: {
      organization_type: 'enterprise' | 'government' | 'research' | 'individual';
      sector?: string | null;
      country?: string | null;
      role?: string | null;
      organization_size?: string | null;
      business_challenge?: string | null;
      transformation_objective?: string | null;
      timeline?: string | null;
      budget_range?: string | null;
      regulatory_exposure?: string | null;
    };
  }) => api.post<{ session_id: string; lead_score_band: string; recommended_track: string; next_state: string }>('/api/lisa/qualify', input),

  handover: (input: { session_id: string; reason: string; consent_to_share_summary: true }) => api.post<LisaHandoverResponse>('/api/lisa/handover', input),

  appointment: (input: { session_id: string; purpose: string; preferred_slots: string[]; contact: { name: string; email: string; phone?: string; organization: string } }) =>
    api.post<{ session_id: string; request_id: string; status: string; confirmed_slot: string | null }>('/api/lisa/appointment', input),
};

export const voiceApi = {
  config: () => api.get<{ stt_provider: string; tts_provider: string }>('/api/voice/config'),
};
